import { render } from "./FollowList.vue?vue&type=template&id=43784197&scoped=true"
import script from "./FollowList.vue?vue&type=script&lang=js"
export * from "./FollowList.vue?vue&type=script&lang=js"

import "./FollowList.vue?vue&type=style&index=0&id=43784197&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43784197"]])

export default __exports__